import moment from "moment";

export const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});


function getDaysInMonth(year, month) {
  const date = moment({
    year: year !== undefined ? year : moment().year(),
    month: month !== undefined ? month - 1 : moment().month(),
  });

  return date.daysInMonth();
}


export const getConfigDaily = (month, year, type) => {
    const currentTotalMonth = getDaysInMonth(year, month);
    const daysArray = Array.from({ length: currentTotalMonth }, (_, i) => ({
      name: String(i + 1),
      label: i + 1,
      options: { sort: false },
    }));
    return [
      {
        name: "employeeName",
        label: type == "sales" ? "Nama Sales / CS" : "Nama TL",
        options: { sort: false },
      },
      ...daysArray,
      {
        name: "total",
        label: "Total",
        options: { sort: false },
      },
      {
        name: "target",
        label: "Target",
        options: { sort: false },
      },
      {
        name: "achievement",
        label: "%achv",
        options: { sort: false },
      },
      {
        name: "projection",
        label: "Proyeksi",
        options: { sort: false },
      },
    ];
}

export const configYearToDate = (year) => [
    { name: "paymentName", label: "\n", options: { sort: false } },
    { name: "january", label: "JAN", options: { sort: false } },
    { name: "february", label: "FEB", options: { sort: false } },
    { name: "march", label: "MAR", options: { sort: false } },
    { name: "april", label: "APR", options: { sort: false } },
    { name: "may", label: "MAY", options: { sort: false } },
    { name: "june", label: "JUN", options: { sort: false } },
    { name: "july", label: "JUL", options: { sort: false } },
    { name: "august", label: "AUG", options: { sort: false } },
    { name: "september", label: "SEP", options: { sort: false } },
    { name: "october", label: "OCT", options: { sort: false } },
    { name: "november", label: "NOV", options: { sort: false } },
    { name: "december", label: "DEC", options: { sort: false } },
    { name: "yearToDateTotal", label: year || moment().format("YYYY"), options: { sort: false } },
];

export const configSalesBySales = [
    { name: "date", label: "Tanggal", options: { sort: false } },
    { name: "dailyCash", label: "Cash\nHarian", options: { sort: false } },
    { name: "accumulateCash", label: "Cash\nAkumulasi", options: { sort: false } },
    { name: "spCash", label: "Cash\n%sp", options: { sort: false } },
    { name: "dailyKDS", label: "KDS\nHarian", options: { sort: false } },
    { name: "accumulateKDS", label: "KDS\nAkumulasi", options: { sort: false } },
    { name: "spKDS", label: "KDS\n%sp", options: { sort: false } },
    { name: "dailyCredit", label: "Kredit\nHarian", options: { sort: false } },
    { name: "spCredit", label: "Kredit\n%sp", options: { sort: false } },
    { name: "accumulateCredit", label: "Kredit\nAkumulasi", options: { sort: false } },
    { name: "dailyTotal", label: "Total\nHarian", options: { sort: false } },
    { name: "accumulateTotal", label: "Total\nAkumulasi", options: { sort: false } },
];

export const configMonthToDate = [
    {name: "displayName", label: "\n", options: {sort: false,}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,}},
    {name: "projection", label: "Proyeksi", options: {sort: false,}},
];

export const configLast3Years = (val) => {
  const year = val ? Number(val) : Number(moment().format("YYYY"));
  return [
    { name: "name", label: "Nama Sales/CS", options: { sort: false } },
    { name: "q1y2", label: `Q1 ${year - 2}`, options: { sort: false } },
    { name: "q2y2", label: `Q2 ${year - 2}`, options: { sort: false } },
    { name: "q3y2", label: `Q3 ${year - 2}`, options: { sort: false } },
    { name: "q4y2", label: `Q4 ${year - 2}`, options: { sort: false } },
    { name: "q1y1", label: `Q1 ${year - 1}`, options: { sort: false } },
    { name: "q2y1", label: `Q2 ${year - 1}`, options: { sort: false } },
    { name: "q3y1", label: `Q3 ${year - 1}`, options: { sort: false } },
    { name: "q4y1", label: `Q4 ${year - 1}`, options: { sort: false } },
    { name: "q1y", label: `Q1 ${year}`, options: { sort: false } },
    { name: "q2y", label: `Q2 ${year}`, options: { sort: false } },
    { name: "q3y", label: `Q3 ${year}`, options: { sort: false } },
    { name: "q4y", label: `Q4 ${year}`, options: { sort: false } },
  ];
};

export const transformResponseLastThreeYearsToTable = (val) => {
    const data = val.dataSales.map((item, index) => ({
        no: index + 1,
        name: item.name,
        q1y2: item.quartal.year2Quartal1,
        q2y2: item.quartal.year2Quartal2,
        q3y2: item.quartal.year2Quartal3,
        q4y2: item.quartal.year2Quartal4,
        q1y1: item.quartal.year1Quartal1,
        q2y1: item.quartal.year1Quartal2,
        q3y1: item.quartal.year1Quartal3,
        q4y1: item.quartal.year1Quartal4,
        q1y: item.quartal.yearQuartal1,
        q2y: item.quartal.yearQuartal2,
        q3y: item.quartal.yearQuartal3,
        q4y: item.quartal.yearQuartal4
    }));

    data.push({
        no: "",
        name: "TOTAL",
        q1y2: val.totalYearMinus2q1,
        q2y2: val.totalYearMinus2q2,
        q3y2: val.totalYearMinus2q3,
        q4y2: val.totalYearMinus2q4,
        q1y1: val.totalYearMinus1q1,
        q2y1: val.totalYearMinus1q2,
        q3y1: val.totalYearMinus1q3,
        q4y1: val.totalYearMinus1q4,
        q1y: val.totalThisYearq1,
        q2y: val.totalThisYearq2,
        q3y: val.totalThisYearq3,
        q4y: val.totalThisYearq4,
    });

    return data;
}

export const configVariantSales = [
    { name: "segmen", label: "Segmen", options: { sort: false } },
    { name: "kodeVarian", label: "Kode Varian", options: { sort: false } },
    { name: "namaVarian", label: "Nama Varian", options: { sort: false } },
    { name: "totalLastMonth", label: "Total\nLast Month", options: { sort: false } },
    { name: "totalThisMonth", label: "Total\nThis Month", options: { sort: false } },
    { name: "totalGrowth", label: "Growth", options: { sort: false } },
    { name: "projection", label: "Proyeksi", options: { sort: false } },
    { name: "cashLastMonth", label: "Cash\nLast Month", options: { sort: false } },
    { name: "cashThisMonth", label: "Cash\nThis Month", options: { sort: false } },
    { name: "cashGrowth", label: "Growth", options: { sort: false } },
    { name: "creditLastMonth", label: "Credit\nLast Month", options: { sort: false } },
    { name: "creditThisMonth", label: "Credit\nThis Month", options: { sort: false } },
    { name: "creditGrowth", label: "Growth", options: { sort: false } },
];

export const configVariantSalesYearToDate = (year) => [
    {name: "segmen", label: "Segmen", options: {sort: false}},
    {name: "kodeVarian", label: "Kode Varian", options: {sort: false}},
    {name: "namaVarian", label: "Nama Varian", options: {sort: false}},
    {name: "jan", label: "JAN", options: {sort: false}},
    {name: "feb", label: "FEB", options: {sort: false}},
    {name: "mar", label: "MAR", options: {sort: false}},
    {name: "apr", label: "APR", options: {sort: false}},
    {name: "may", label: "MAY", options: {sort: false}},
    {name: "jun", label: "JUN", options: {sort: false}},
    {name: "jul", label: "JUL", options: {sort: false}},
    {name: "aug", label: "AUG", options: {sort: false}},
    {name: "sep", label: "SEP", options: {sort: false}},
    {name: "oct", label: "OCT", options: {sort: false}},
    {name: "nov", label: "NOV", options: {sort: false}},
    {name: "dec", label: "DEC", options: {sort: false}},
    {name: "yearToDate", label: year || moment().format("YYYY"), options: {sort: false}},
];

const SPACER_DATA = {
  leasingName: "",
  lastMonth: null,
  thisMonth: null,
  growth: null,
  projection: null,
};


export const transformResponseMTD = (data) => {
  if (!data) return [];

  const {
    dataLeasing = [],
    dataNonLeasing = [],
    dataTotalLeasing = {},
    dataTotalNonLeasing = {},
  } = data;

  // Proses data leasing
  const combinedLeasing = [
    ...dataLeasing.map(item => ({
      ...item,
      displayName: item.leasingName,
    })),
    {
      displayName: "Total Leasing",
      lastMonth: dataTotalLeasing.totalLastMonth,
      thisMonth: dataTotalLeasing.totalThisMonth,
      growth: dataTotalLeasing.totalGrowth,
      projection: dataTotalLeasing.totalProjection,
    },
  ];

  // Proses data non-leasing
  const combinedNonLeasing = [
    ...dataNonLeasing.map(item => ({
      ...item,
      displayName: item.paymentMethod,
    })),
    {
      displayName: "Total",
      lastMonth: dataTotalNonLeasing.totalLastMonth,
      thisMonth: dataTotalNonLeasing.totalThisMonth,
      growth: dataTotalNonLeasing.totalGrowth,
      projection: dataTotalNonLeasing.totalProjection,
    },
  ];

  // Gabungkan hasil
  return [...combinedNonLeasing, SPACER_DATA, ...combinedLeasing];
};

export const transformResponseYearsToDateToTable = (val) => {
    const result = [];

    // Payment Group1
    const group1 = val.paymentGroup1.map(item => ({
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));
    result.push(...group1);

    // Total Group 1
    result.push({
        paymentName: "Total",
        ...val.paymentTotalGroup1.totalPaymentPerGroup,
        yearToDateTotal: val.paymentTotalGroup1.allTotalPayment
    });

    // separator kosong
    result.push({
        paymentName: "",
        january: "",
        february: "",
        march: "",
        april: "",
        may: "",
        june: "",
        july: "",
        august: "",
        september: "",
        october: "",
        november: "",
        december: "",
        yearToDateTotal: ""
    });

    // Payment Group2 
    const group2 = val.paymentGroup2.map(item => ({
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));

    result.push(...group2);

    // Total Group 2 
    result.push({
        paymentName: "TOTAL",
        ...val.paymentTotalGroup2.totalPaymentPerGroup,
        yearToDateTotal: val.paymentTotalGroup2.allTotalPayment
    });

    return result;
}